import { useMutation, gql } from "@apollo/client"
import { CATEGORIES_FIELDS } from "./useQueryCategories"

const UPDATECATEGORY_MUTATION = gql`
  mutation UpdateCategory($id: ID!, $name: String!, $description: String, $icon: String!, $groups: [ID!], $locations: [ID!]) {
    updateCategory(id: $id, name: $name, description: $description, icon: $icon, groups: $groups, locations: $locations) {
      ${CATEGORIES_FIELDS}
    } 
  }
`

const useMutationUpdateCategory = () => useMutation(UPDATECATEGORY_MUTATION)

export { useMutationUpdateCategory }
